<p>
    <mat-button-toggle-group [(ngModel)]="viewModelExport.fileType">
        <mat-button-toggle value="File">File</mat-button-toggle>
        <mat-button-toggle value="Excel">Excel</mat-button-toggle>
        <mat-button-toggle value="Feather">Feather</mat-button-toggle>
    </mat-button-toggle-group>
    <button mat-button class="export-hover-btn"(click)="onClickExportOutput()" style="color: #1ea9d3;margin-left: 10px;height: 32px;display: inline-flex; align-items: center;vertical-align: middle;flex-direction: row;gap: 6px; white-space: nowrap;line-height: 1;">
        <img src="../assets/images/exporticon.png" style="width: auto;display: inline-block;vertical-align: middle;object-fit: contain;"/>
        <span>EXPORT</span>
    </button>
    <button mat-button class="export-hover-btn"(click)="saveExportConfig()" style="color: #1ea9d3;margin-left: 10px;height: 32px;">
        <mat-icon style="color:white;margin-right:5px !important">save</mat-icon>
        <span>SAVE CONFIG</span>
    </button>
</p>
<p *ngIf="this.viewModelExport.fileType=='File'">
    <mat-form-field appearance="outline" style="width: 120px;">
        <mat-label>Delimiter</mat-label>
        <!-- <input type="text"
           placeholder="Select the column delimiter"
           matInput
           [matAutocomplete]="autodelimiter"
           [(ngModel)]="viewModelExport.fileDelimiter" [formControl]="fileDelimiterControl">
        <mat-autocomplete autoActiveFirstOption #autodelimiter="matAutocomplete">
            <mat-option *ngFor="let delimiter of delimiterOptions | async" [value]="delimiter">
                {{delimiter}}
            </mat-option>
        </mat-autocomplete> -->

        <mat-select [(ngModel)]="viewModelExport.fileDelimiter" (selectionChange)="OnDelimiterChange()" >
            <mat-option value=",">comma (,)</mat-option>
            <mat-option value="[tab]">tab (\\t)</mat-option>
            <mat-option value="|">pipe (|)</mat-option>
            <mat-option value=":">colon (:)</mat-option>
            <mat-option value="~">tilde (~)</mat-option>
            <mat-option value=";">semicolon (;)</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 123px;margin-left: 10px;">
        <mat-label>Extension</mat-label>
        <!-- <input type="text"
           placeholder="Select the file Extension"
           matInput
           [matAutocomplete]="autoextension"
           [(ngModel)]="viewModelExport.fileExtension" [formControl]="fileExtensionControl">
        <mat-autocomplete autoActiveFirstOption #autoextension="matAutocomplete">
            <mat-option *ngFor="let extension of extensionOptions | async" [value]="extension">
                {{extension}}
            </mat-option>
        </mat-autocomplete> -->

        <mat-select [(ngModel)]="viewModelExport.fileExtension">
            <mat-option value=".csv">.csv</mat-option>
            <mat-option value=".txt">.txt</mat-option>
        </mat-select>
    </mat-form-field>
</p>
<p>
    Include Columns
</p>
<!-- <table *ngIf="ingestConfig.hasColumns()" mat-table [dataSource]="dataSourceExport" class="mat-elevation-z8"> -->
    <table mat-table (cdkDropListDropped)="dropExportColumnTable($event)" cdkDropList [dataSource]="dataSourceExport" class="drag-list mat-elevation-z8">
    <ng-container matColumnDef="order">
        <th mat-header-cell *matHeaderCellDef style="width: 20px; margin-left: 3px; margin-right: 3px; "> Order </th>
        <td mat-cell *matCellDef="let def" style="width: 20px; margin-left: 3px; margin-right: 3px; ">
            <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center">
                <mat-icon color="primary" matTooltip="Re-order column"  style="cursor: grab" cdkDrag [cdkDragData]="exportcolumninfo"
                    cdkDragRootElement=".drag-component" cdkDragHandle>reorder</mat-icon>
            </div>
        </td>
    </ng-container>
    <!-- <ng-container matColumnDef="index">
        <th mat-header-cell *matHeaderCellDef style="width: 20px; margin-left: 3px; margin-right: 3px; ">
           index
        </th>
        <td mat-cell *matCellDef="let def" style="width: 20px; margin-left: 3px; margin-right: 3px; "> 
            {{def.index}}
        </td>
    </ng-container> -->
    <ng-container matColumnDef="include">
        <th mat-header-cell *matHeaderCellDef style="width: 20px; margin-left: 3px; margin-right: 3px; ">
            <mat-slide-toggle  color="primary" (change)="onExportIncludeChanged($event)"></mat-slide-toggle>
        </th>
        <td mat-cell *matCellDef="let def" style="width: 20px; margin-left: 3px; margin-right: 3px; "> 
            <mat-slide-toggle color="primary" [(ngModel)]="def.isinclude"></mat-slide-toggle>
        </td>
    </ng-container>
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef style="width: 150px;margin-left: 3px; margin-right: 3px; "> Name </th>
        <td mat-cell *matCellDef="let def" style="width: 150px;"> {{def.name}} </td>
    </ng-container>
    <ng-container matColumnDef="targetcolumn">
        <th mat-header-cell *matHeaderCellDef style="width: 200px;margin-left: 3px; margin-right: 3px; "> 
            <mat-slide-toggle  color="primary" (change)="onUseSourceChanged($event)" [(ngModel)]="isUseSource">Use Source </mat-slide-toggle><br>
            Enter Target Column
        </th>
        <td mat-cell *matCellDef="let def;let i = index" style="width: 150px;"> 
            <input matInput #targetInput placeholder="Enter Target Column" type="text" [(ngModel)]="def.targetcolumn" [disabled]="isUseSource" [ngClass]="{'disabled-input': isUseSource}" 
            (keydown.enter)="handleMoveToField('forward', i, $event)"
            (keydown.shift.enter)="handleMoveToField('reverse', i, $event)"
            (keydown.tab)="handleMoveToField('forward', i, $event)"
            (keydown.shift.tab)="handleMoveToField('reverse', i, $event)"
            >
        </td>
    </ng-container>
    <ng-container matColumnDef="dataType">
        <th mat-header-cell *matHeaderCellDef style="width: 80px;margin-left: 3px; margin-right: 3px; "> Data Type </th>
        <td mat-cell *matCellDef="let def" style="width: 80px;margin-left: 3px; margin-right: 3px; "> {{def.dataType}} </td>
    </ng-container>

    <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef style="margin-left: 3px; margin-right: 3px; "> Description </th>
        <td style="width: auto; margin-left: 3px; margin-right: 3px; color: gray" mat-cell *matCellDef="let def"> {{def.description}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsExport"></tr>
    <tr class="drag-component" mat-row *matRowDef="let row; columns: displayedColumnsExport;"></tr>
    <div *cdkDragPlaceholder></div>
</table>